// extracted by mini-css-extract-plugin
export default {"fade-in":"PortfolioBlock_fade-in__WUkqx","visible":"PortfolioBlock_visible__Cjren"};